export default class RelationshipModel {
  constructor (data) {
    this.person = null
    this.target = null

    this.values = {
      id: null,
      person_id: null,
      target_id: null,
      description: null
    }

    window.PRIM.modelMapper.mapToModel(data, this.values)
  }

  getTitle () {
    let title = []

    if (this.target && this.target.getTitle) {
      return this.target.getTitle()
    }

    return title.join(' ')
  }
  getSubtitle () {
    return [this.values.description].join(' ')
  }
  getImage () {
    if (this.target && this.target.getImage) {
      return this.target.getImage()
    } else {
      return null
    }
  }
  getIndex () {
    if (this.target && this.target.getIndex) {
      return this.target.getIndex()
    }

    return null
  }
  getCompareString () {
    let title = []

    if (this.target && this.target.getCompareString) {
      title.push(this.target.getCompareString())
    }

    if (this.values.description) {
      title.push(this.values.description)
    }

    return title.join(' ')
  }

  getJSON () {
    let result = {}

    window.PRIM.modelMapper.mapToObject(this.values, result)

    return result
  }
}



// WEBPACK FOOTER //
// ./js/modules/relationship/model/RelationshipModel.js